import { AxiosInstance, AxiosResponse } from 'axios';
import { TLocaleAPI } from '../types/locale';
import { TNoonReviewResponse, TNoonReviewInput } from '../types/review';

export type TReviewEndpoint = {
    getNoonReview: (params?: TNoonReviewInput) => Promise<AxiosResponse<TNoonReviewResponse>>;
};
export default (api: AxiosInstance, apiLocale: TLocaleAPI): TReviewEndpoint => {
    const getNoonReview = async (params?: TNoonReviewInput): Promise<AxiosResponse<TNoonReviewResponse>> =>
        api.post(`/_svc/reviews/fetch/v1/product-reviews/list`, params, { headers: { 'x-locale': apiLocale } });

    return {
        getNoonReview,
    };
};
